import { formatAmount } from '~/@lib/utils/number.utils'
import { UnsophisticatedAgreementForm } from './UnsophisticatedAgreementForm'

// len do textu, `riskTolerance` počíta API
const riskTolerancePercentage = 10

type Props = {
  isLoading: boolean
  isExperiencedInvestor: boolean
  // null, ak user dotazník dokončil pred ukladaním výsledkov na API
  nettoAssets: number | null
  riskTolerance: number | null
  onSign(): void
}

export function UnsophisticatedInvestorSignAgreement({
  isLoading,
  isExperiencedInvestor,
  nettoAssets,
  riskTolerance,
  onSign,
}: Props) {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5">
        <p className="text-[40px] font-semibold leading-[52px]">Gratulujeme!</p>
        <p className="font-medium">
          {isExperiencedInvestor
            ? 'Na základe vaších vyplnených odpovedí v dotazníku ste zodpovedný investor.'
            : 'Sme radi, že ste sa rozhodli investovať s nami!'}{' '}
          {nettoAssets !== null && riskTolerance !== null && (
            <>
              Váš čistý majetok predstavuje {formatAmount(nettoAssets)}.{' '}
              {riskTolerancePercentage}% z Vášho čistého majetku je{' '}
              {formatAmount(riskTolerance)}.
            </>
          )}
        </p>
      </div>
      <p className="font-medium">
        Na vašu e-mailovú adresu sme zaslali dokument Informačné povinnosti
        dodávateľa.
      </p>
      <p className="font-medium">
        Pre dokončenie registrácie stačí podpísať rámcovú zmluvu.
      </p>
      <UnsophisticatedAgreementForm
        isSigningAgreement={isLoading}
        onSign={onSign}
      />
    </div>
  )
}
